import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DadosContatosService } from "src/app/services/dados-contatos.service";
import { obterDadosContatos, obterDadosContatosSuccess } from "../actions/obter-dados-contatos.action";
import { mergeMap, map, catchError, of } from "rxjs";

@Injectable()
export class ObterDadosContatosEffects {

  public obterDadosContatos$: unknown;

  constructor(private actions$: Actions,
    private dadosContatosService: DadosContatosService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterDadosContatos$ = createEffect(() => this.actions$.pipe(
      ofType(obterDadosContatos),
      mergeMap(() =>
        this.dadosContatosService.ObterDadosContatos()
        .pipe(map(response => {
          return obterDadosContatosSuccess({ response });
        }),
          catchError(() => of())
        )
      )
    )
    );
  }
}
